import { createStore } from 'vuex'

// 🔐 Auth
import authState from './modules/auth/state'
import authGetters from './modules/auth/getters'
import authMutations from './modules/auth/mutations'
import authActions from './modules/auth/actions'

// 🔍 Search
import searchState from './modules/search/state'
import searchGetters from './modules/search/getters'
import searchMutations from './modules/search/mutations'
import searchActions from './modules/search/actions'

// // 📦 Products
// import productsState from './modules/products/state'
// import productsMutations from './modules/products/mutations'
// import productsActions from './modules/products/actions'

// 👥 Users
import usersState from './modules/users/state'
import usersGetters from './modules/users/getters'
import usersMutations from './modules/users/mutations'
import usersActions from './modules/users/actions'

// 🧾 Facilities
import facilitiesState from './modules/facilities/state'
import facilitiesGetters from './modules/facilities/getters'
import facilitiesMutations from './modules/facilities/mutations'
import facilitiesActions from './modules/facilities/actions'


// 🧾 Orders
import ordersState from './modules/orders/state'
import ordersGetters from './modules/orders/getters'
import ordersMutations from './modules/orders/mutations'
import ordersActions from './modules/orders/actions'

// 🧾 Invoices
import invoicesState from './modules/invoices/state'
import invoicesGetters from './modules/invoices/getters'
import invoicesMutations from './modules/invoices/mutations'
import invoicesActions from './modules/invoices/actions'

// ⚙️ Settings
import settingsState from './modules/settings/state'
import settingsGetters from './modules/settings/getters'
import settingsMutations from './modules/settings/mutations'
import settingsActions from './modules/settings/actions'


// 🛒 Cart
import cartState from './modules/cart/state'
import cartGetters from './modules/cart/getters'
import cartMutations from './modules/cart/mutations'
import cartActions from './modules/cart/actions'


// CHECKOUT
import checkoutState from './modules/checkout/state'
import checkoutGetters from './modules/checkout/getters'
import checkoutMutations from './modules/checkout/mutations'
import checkoutActions from './modules/checkout/actions'

// REPORTS
import reportsState from './modules/reports/state'
import reportsGetters from './modules/reports/getters'
import reportsMutations from './modules/reports/mutations'
import reportsActions from './modules/reports/actions'

// UI
import uiState from './modules/ui/state'
import uiGetters from './modules/ui/getters'
import uiMutations from './modules/ui/mutations'
import uiActions from './modules/ui/actions'

// SERCH BOT
import searchBotState from './modules/search-bot/state' 
import searchBotGetters from './modules/search-bot/getters'
import searchBotMutations from './modules/search-bot/mutations'
import searchBotActions from './modules/search-bot/actions'

export default createStore({
  modules: {
    // 🔐 AUTH MODULE
    auth: {
      namespaced: true,
      state: authState,
      getters: authGetters,
      mutations: authMutations,
      actions: authActions
    },

    // 🔍 SEARCH MODULE
    search: {
      namespaced: true,
      state: searchState,
      getters: searchGetters,
      mutations: searchMutations,
      actions: searchActions
    },

    // // 📦 PRODUCTS MODULE
    // products: {
    //   namespaced: true,
    //   state: productsState,
    //   mutations: productsMutations,
    //   actions: productsActions
    // },

    // // 👥 USERS MODULE
    users: {
      namespaced: true,
      state: usersState,
      getters: usersGetters,
      mutations: usersMutations,
      actions: usersActions
    },

    // 🧾 FACILITIES MODULE
    facilities: {
      namespaced: true,
      state: facilitiesState,
      getters: facilitiesGetters,
      mutations: facilitiesMutations,
      actions: facilitiesActions
    },

    // 🧾 ORDERS MODULE
    orders: {
      namespaced: true,
      state: ordersState,
      getters: ordersGetters,
      mutations: ordersMutations,
      actions: ordersActions
    },

    // 🧾 INVOICES MODULE
    invoices: {
      namespaced: true,
      state: invoicesState,
      getters: invoicesGetters,
      mutations: invoicesMutations,
      actions: invoicesActions
    },

    // ⚙️ SETTINGS MODULE
    settings: {
      namespaced: true,
      state: settingsState,
      getters: settingsGetters,
      mutations: settingsMutations,
      actions: settingsActions
    },

    // 🛒 CART MODULE
    cart: {
      namespaced: true,
      state: cartState,
      getters: cartGetters,
      mutations: cartMutations,
      actions: cartActions
    },

    // CHECKOUT MODULE
    checkout: {
      namespaced: true,
      state: checkoutState,
      getters: checkoutGetters,
      mutations: checkoutMutations,
      actions: checkoutActions
    },

    // REPORTS MODULE
    reports: {
      namespaced: true,
      state: reportsState,
      getters: reportsGetters,
      mutations: reportsMutations,
      actions: reportsActions
    },
    
    // UI MODULE
    ui: {
      namespaced: true,
      state: uiState,
      getters: uiGetters,
      mutations: uiMutations,
      actions: uiActions
    },

    // SERCH BOT MODULE
    searchBot: {
      namespaced: true,
      state: searchBotState,
      getters: searchBotGetters,
      mutations: searchBotMutations,
      actions: searchBotActions
    }
  }
})